<div class="ps-2 name-tag" [class.name-tag-alert]="redBorder">
  {{ fileName }}
  <ng-content select="[statusIcon]"> </ng-content>
  <button class="btn px-2 clean-button" (click)="buttonClicked()">
    <svg viewBox="0 0 8 8" class="name-tag-close">
      <use xlink:href="#cross-solid"></use>
    </svg>
  </button>
</div>
